import { createContext, useState } from "react";
import { RouteType } from "../components/Navigation/Routes/CreateRoutes";

type initialStateType = {
  permissions?: string[];
  setPermissions?: Function;
  routes?: RouteType[];
  setRoutes?: Function;
  global?: any;
  setGlobal?: Function;
};

export const initialState: initialStateType = {
  permissions: [],
  routes: [],
  global: {},
};

const store = createContext(initialState);
const { Provider } = store;

const ContextProvider = ({ children }: any) => {
  const [permissions, setPermissions] = useState(initialState.permissions);

  const [routes, setRoutes] = useState(initialState.routes);

  const [global, setGlobal] = useState(initialState.global);

  return (
    <Provider
      value={{
        permissions,
        setPermissions,
        routes,
        setRoutes,
        global,
        setGlobal,
      }}
    >
      {children}
    </Provider>
  );
};

export { store, ContextProvider };
